module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Contact1-f119cbc12bb86a1ac0c165f5185c2ff4.svg";